<template>
  <div class="cbc-pay-dialog">
    <span
      class="close-icon"
      @click="close"
    />
    <div class="pay-header">
      <span
        class="icon"
        :class="position"
      />
      <p class="main">
        {{ cardInfo.bankName }}
      </p>
      <p class="sub">
        尾号{{ cardInfo.cardNo }}
      </p>
    </div>
    <div class="main-content">
      <p
        class="tip-text"
        v-show="cardInfo.mobile"
      >
        验证码将发送至{{ cardInfo.mobile }}
      </p>
      <ul class="code">
        <li
          class="item"
          v-for="(item, index) in smsCode"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
      <p
        :class="['fetch', { 'invalid': count != 60 }]"
        @click="send"
      >
        {{ text }}
      </p>
    </div>
    <button
      class="btn"
      @click="submit"
    >
      <span class="sum">￥{{ this.sum }}</span>立即支付
    </button>
  </div>
</template>

<script>
  const positions = {
    '建设': 'a',
    '工商': 'b',
    '邮政': 'c',
    '交通': 'd',
    '中国银行': 'e',
    '农业': 'ly',
    '中信': 'zx',
    '光大': 'gd',
    '民生': 'ms',
    '广发': 'gf',
    '招商': 'zs',
    '兴业': 'xy',
    '浦发': 'pf',
    '恒丰': 'hf',
    '浙商': 'zsyx',
    '渤海': 'bh',
    '平安': 'pa',
    '华夏': 'hx'
  }
  export default {
    name: 'CBCPayDialog',
    props: {
      code: {
        type: String,
        default: ''
      },
      cardInfo: {
        type: Object,
        default() {
          return {}
        }
      },
      clearSmsTime: {
        type: Boolean
      },
      sum:{
        type: Number,
        default: 0
      }
    },
    computed: {
      smsCode() {
        return Object.assign(['', '', '', '', '', ''], this.code.split(''))
      },
      position() {
        let position = ''
        const keys = Object.keys(positions)
        for (let i = 0; i < keys.length; i++) {
          if (this.cardInfo.bankName.indexOf(keys[i]) > -1) {
            position = positions[keys[i]]
            break
          }
        }
        return position
      }

    },
    data() {
      return {
        hasCalledApi: false,
        count: 60,
        text: '获取验证码'
      }
    },
    mounted() {
      this.send()
    },
    methods: {
      close() {
        this.$emit('on-close')
      },
      send() {
        this.hasCalledApi = true
        if (this.timerId) return
        this.timerId = setInterval(() => {
          this.count--
          this.text = `${this.count}秒后重试`
          if (this.count <= 0) {
            this.clear()
          }
        }, 1000)
        this.$emit('on-send')
      },
      clear() {
        if (this.timerId) {
          clearInterval(this.timerId)
          this.timerId = false
          this.text = '重新获取验证码'
          this.count = 60
        }
      },
      submit() {
        if (this.smsCode.every(i => !!i)) {
          if (this.hasCalledApi) {
            this.$emit('on-submit')
          } else {
            this.$toast('请获取验证码')
          }
        } else {
          this.$toast('请输入验证码')
        }
      }
    },
    watch: {
      clearSmsTime(val) {
        if (val) {
          this.clear()
        }
      }
    },
    destroyed() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cbc-pay-dialog {
    width: 78%;
    background: #fff;
    border-radius: 24px;
    position: absolute;
    left: 50%;
    top: 15%;
    padding: 40px 75px 60px;
    transform: translate3d(-50%, -15%, 0);
    z-index: 100;
    .close-icon {
      position: absolute;
      width: 80px;
      height: 80px;
      top: 20px;
      right: 20px;
      display: inline-block;
      background: url('../assets/image/close2.png') center no-repeat;
      background-size: 40px;
    }
    .pay-header {
      padding-left: 120px;
      position: relative;
      height: 150px;
      padding: 15px 0 15px 130px;
      .icon {
        position: absolute;
        top: 10px;
        left: 0;
        display: inline-block;
        width: 120px;
        height: 120px;
        background-image: url('../assets/image/icon-pay.png');
        background-repeat: no-repeat;
        background-size: 120px;
        background-position: 0 0px;
        &.a {
          background-position: 0 -220px;
        }
        &.b {
          background-position: 0 -327px;
        }
        &.c {
          background-position: 0 -550px;
        }
        &.d {
          background-position: 0 -435px;
        }
        &.e {
          background-position: 0 -110px;
        }
        &.ly{
          background-image: url('../assets/image/bank-imgs/ly.png');
        }
        &.zx{
          background-image: url('../assets/image/bank-imgs/zx.png');
        }
        &.gd{
          background-image: url('../assets/image/bank-imgs/gd.png');
        }
        &.ms{
          background-image: url('../assets/image/bank-imgs/ms.png');
        }
        &.zs{
          background-image: url('../assets/image/bank-imgs/zs.png');
        }
        &.xy{
          background-image: url('../assets/image/bank-imgs/xy.png');
        }
        &.pf{
          background-image: url('../assets/image/bank-imgs/pf.png');
        }
        &.hf{
          background-image: url('../assets/image/bank-imgs/hf.png');
        }
        &.zsyx{
          background-image: url('../assets/image/bank-imgs/zsyx.png');
        }
        &.bh{
          background-image: url('../assets/image/bank-imgs/bh.png');
        }
        &.pa{
          background-image: url('../assets/image/bank-imgs/pa.png');
        }
        &.hx{
          background-image: url('../assets/image/bank-imgs/hx.png');
        }
      }
      .main {
        font-size: 42px;
        color: #000;
        margin-bottom: 15px;
      }
      .sub {
        font-size: 36px;
        color: #666;
        line-height: 40px;
      }
    }
    .main-content {
      margin-top: 40px;
      .tip-text {
        font-size: 42px;
        color: #000;
      }
      .code {
        margin-top: 40px;
        display: flex;
        li {
          flex: 1;
          height: 120px;
          line-height: 120px;
          text-align: center;
          border-top: 1px solid #dedee0;
          border-bottom: 1px solid #dedee0;
          border-right: 1px solid #dedee0;
          border-left: none;
          font-size: 54px;
          font-weight: bold;
          &:first-child {
            border-left: 1px solid #dedee0;
          }
        }
      }
      .fetch {
        margin-top: 42px;
        text-align: center;
        font-size: 36px;
        color: #0081fa;
        text-decoration: underline;
        &.invalid {
          color: #666;
        }
      }
    }
    .btn {
      width: 100%;
      display: block;
      height: 108px;
      font-size: 45px;
      color: #000;
      font-weight: 400;
      background-color: #ffd013;
      margin-top: 100px;
      line-height: 100px;
      border-radius: 54px;
      .sum{
        font-weight: bold;
        padding-right: 10px;
      }
    }
  }
</style>
